import { memo } from "react"
import { useNavigate } from "@tanstack/react-router"
import {
	IconAtom2Outline18,
	IconBookOpen4Outline18,
} from "nucleo-ui-outline-18"

import { Button, Empty } from "@productlane/ui"

import { PageHeader } from "../page-header"
import { AgentOffWidgetPreview } from "./agent-off-widget-preview"

export const AGENT_SETTINGS_PATH = "/settings/ai/agent"
export const AGENT_DOCS_URL = "https://productlane.com/docs/ai/ai-agent"

export const AGENT_OFF_TITLE = "Let the AI Agent answer first"
export const AGENT_OFF_DESCRIPTION =
	"The agent replies to customers in seconds, grounded in your help center and code. It passes the rest to your team. Each morning it reviews what it couldn't solve and suggests fixes for your approval."

// isEnabled is the master switch: with it off the agent answers on no channel,
// whatever the per-channel deploy toggles say.
export function isAgentTurnedOff(
	settings: { isEnabled?: boolean | null } | null | undefined,
): boolean {
	return settings?.isEnabled !== true
}

export const AgentOffState = memo(() => {
	const navigate = useNavigate()

	return (
		<div className="flex h-full min-h-0 flex-col">
			<PageHeader title="Agent" />
			<div className="min-h-0 flex-1 overflow-y-auto">
				<div className="flex min-h-full flex-col items-center justify-center px-6 pb-10 pt-10">
					<Empty
						image={<IconAtom2Outline18 className="h-8 w-8 text-secondary" />}
						title={AGENT_OFF_TITLE}
						text={AGENT_OFF_DESCRIPTION}
						action={
							<div className="flex gap-2">
								<Button
									onClick={() => void navigate({ href: AGENT_SETTINGS_PATH })}
								>
									Turn on AI Agent
								</Button>
								<Button
									variant="outline"
									Icon={IconBookOpen4Outline18}
									onClick={() =>
										window.open(AGENT_DOCS_URL, "_blank", "noopener,noreferrer")
									}
								>
									How it works
								</Button>
							</div>
						}
					/>
					<AgentOffWidgetPreview />
				</div>
			</div>
		</div>
	)
})
